import React from "react";
import NavTab from "./NavTab";

const Tabs = () => {
  const tabs = [
    { label: "Tab 1", content: "Content for Tab 1" },
    { label: "Tab 2", content: "Content for Tab 2" },
    { label: "Tab 3", content: "Content for Tab 3" },
  ];
  return (
    <>
      <div>
        <h1>Tabbed Navigation Example</h1>
        <NavTab tabs={tabs} />
      </div>
    </>
  );
};

export default Tabs;
